module.exports = __webpack_public_path__ + "img/service-icon-microwave.1be48138.png";